var MDB = window.MDB || {};
MDB.Icons = MDB.Icons || {};

(function(){
    var extensionCategories = {
        image: {
            extensions: ['png','gif','jpg','jpeg','bmp','psd'],
            icon: 'fa fa-file-image',
            color: '#c4531b'
        },
        sheet: {
            extensions: ['xlsx','xls','csv'],
            icon: 'fa fa-file-excel',
            color: '#1bc46d'
        },
        doc: {
            extensions: ['doc','docx'],
            icon: 'fa fa-file-word',
            color: '#6373e8'
        },
        text: {
            extensions: ['txt'],
            icon: 'fa fa-file-alt',
            color: '#c6bdb8'
        },
        code: {
            extensions: ['js','cs','html','php','sql','java','py','py3','pyc','pyw'],
            icon: 'fa fa-file-code',
            color: '#d1bb4d'
        },
        audio: {
            extensions: ['mp3','wav','wma','ogg','midi','aif','aifc','aiff','au','ea'],
            icon: 'fa fa-file-audio',
            color: '#bc67ab'
        },
        video: {
            extensions: ['avi','mpg','mpeg','mkv','webm','ogv','mov','wmv','mp4','m2v','m4v','3gp'],
            icon: 'fa fa-file-video',
            color: '#e8a655'
        },
        pdf: {
            extensions: ['pdf'],
            icon: 'fa fa-file-pdf',
            color: '#ff0000'
        },
        default: {
            extensions: [],
            icon: 'far fa-file',
            color: undefined
        }
    };

    var allCategoryNames = Object.keys(extensionCategories);

    $.extend(MDB.Icons, {
        getFileIcon: function(name, opts) {
            opts = opts || {};
            
            //First, split our filename/extension on '.'
            var parts = (name || '').split('.');
            
            //then extract the extension
            var extension = parts[parts.length-1];
            var category = getCategory(extension);
            
            return buildIcon(category, opts);
            
            // if(extension) {
            //     if(image.indexOf(extension) != -1) {
            //         return '<i class="fa fa-file-image" style="color:#c4531b; font-weight:bold;"></i>';
            //     } else if(sheet.indexOf(extension) != -1) {
            //         return '<i class="fa fa-file-excel" style="color:#1bc46d; font-weight:bold;"></i>';
            //     } else if(doc.indexOf(extension) != -1) {
            //         return '<i class="fa fa-file-word" style="color:#6373e8; font-weight:bold;"></i>';
            //     } else if(text.indexOf(extension) != -1) {
            //         return '<i class="far fa-file-alt" style="color:#c6bdb8; font-weight:bold;"></i>';
            //     } else if(code.indexOf(extension) != -1) {
            //         return '<i class="fa fa-file-code" style="color:#d1bb4d; font-weight:bold;"></i>';
            //     } else {
            //         return '<i class="far fa-file"></i>';
            //     }
            // }
        }
    });
    
    function buildIcon(category, opts){
        //Setup our base icon
        var icon = '<i class="' + category.icon + '';
        
        //Add the size when configured
        if(opts.size){
            icon += ' fa-' + opts.size
        }

        //Close the 'class' attribute of our icon
        icon += '"';
        
        //Set the color + font-weight when present in our category
        if(category.color){
            icon += ' style="color:' + category.color + ';font-weight:bold;"'
        }
        
        //Close the element tag itself
        icon += '></i>';
        
        return icon;
    }
    
    function getCategory(extension){
        //Start out with default
        var extensionCategory = extensionCategories.default;
        
        //Ensure our extension is in lowercase
        //Otherwise we'll risk accidentally displaying the default icon
        extension = extension.toLowerCase();
        
        //Check to which category our extensions belongs
        allCategoryNames.forEach(function(categoryName){
            var category = extensionCategories[categoryName];
            
            if(category.extensions.indexOf(extension) !== -1){
                extensionCategory = category;
            }
        });
        
        return extensionCategory;
    }
    
}());